import { Grid } from "@mui/material"
import { ISettingsItem } from "../../../Settings"
import { usePlan } from "../../../Plans"
import { useInitReq } from "../../../InitReq"
import { useTranslation } from "../../../i18n"
import PersonalInfo from "./Steps/PersonalInfo"
import ContactInfo from "./Steps/ContactInfo"
/* STEP 1 */
import ChoosePlanText from "../../page1/right/ChoosePlanText"
import SelectChipInfo from "../../page2/left/SelectChipInfo"
import SelectPickUpChip from "./SelectPickUpChip"
import SelectPlanDetails from "../../page1/right/SelectPlanDetails"
/* STEP 3 */
import AdressInfo from "./Steps/AdressInfo"
/* STEP 4 */
import PaymentStep from './Steps/PaymentStep/PaymentStep'

// PORTABILITY VARIABLES
const portabilityVariables = {
  "text": [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'none',
    '',
    '',
  ]
}

export default function Steps({ name }: ISettingsItem) {
  const { step, chipOnly } = usePlan()
  const { physicalChipAvailable, virtualStock } = useInitReq()
  const { t } = useTranslation()

  const pickUpChipTextArray = {
    text: [t.page2.sectionTitles.chipReceive, t.page2.sectionTitles.chipReceiveSub]
  }
  const pickUpVariables = {
    text: [
      t.page2.pickUpChip.atHome,
      t.page2.pickUpChip.atHomeDesc,
      t.page2.pickUpChip.atStore,
      t.page2.pickUpChip.atStoreDesc,
    ]
  }
  const accessTechnologyTextArray = {
    text: [t.page2.sectionTitles.accessTechnology, t.page2.sectionTitles.accessTechnologySub]
  }
  const portabilityTextArray = {
    text: [t.page2.sectionTitles.bonusGain, t.page2.sectionTitles.bonusGainSub]
  }
  const paymentStepArray = {
    text: [
      // À VISTA | PARCELADO
      t.page2.payment.oneTimeTitle,
      t.page2.payment.oneTimeSubtitle,
      t.page2.payment.installmentTitle,
      t.page2.payment.installmentSubtitle,
      t.page2.payment.finalizeInstallmentTitle,
      t.page2.payment.finalizeInstallmentSubtitle,
      // CARTÃO
      t.page2.payment.cardTitle,
      t.page2.payment.cardSubtitle,
      t.page2.payment.cardBadge,
      'flex',
      t.page2.payment.cardNumber,
      t.page2.payment.cardName,
      t.page2.payment.cardCpf,
      t.page2.payment.cardExpiry,
      t.page2.payment.cardCvv,
      // PIX
      t.page2.payment.pixTitle,
      t.page2.payment.pixSubtitle,
      t.page2.payment.pixBadge,
      'flex',
      t.page2.payment.pixStep1Title,
      t.page2.payment.pixStep1Desc,
      t.page2.payment.pixStep2Title,
      t.page2.payment.pixStep2Desc,
      t.page2.payment.pixStep3Title,
      t.page2.payment.pixStep3Desc,
      t.page2.payment.pixExpiresIn,
      // BOLETO
      t.page2.payment.boletoTitle,
      t.page2.payment.boletoSubtitle,
      t.page2.payment.boletoBadge,
      'none',
      t.page2.payment.boletoStep1Title,
      t.page2.payment.boletoStep1Desc,
      t.common.download,
    ]
  }

  const stepContent = [
    <Grid container item className="step step-1" xs={12}>
      {chipOnly ? (
        physicalChipAvailable && virtualStock && (
          <>
            <ChoosePlanText name="pick-up-chip-text" variables={pickUpChipTextArray} />
            <SelectPickUpChip name="chip-only-pick-up" variables={pickUpVariables} />
          </>
        )
      ) : (
        <>
          {(physicalChipAvailable && virtualStock) && (
            <>
              <ChoosePlanText name="access-technology-text" variables={accessTechnologyTextArray} />
              <SelectChipInfo />
            </>
          )}
          <ChoosePlanText name="portability-text" variables={portabilityTextArray} />
          <SelectPlanDetails name="select-portability" variables={portabilityVariables} />
        </>
      )}
    </Grid>,
    <Grid container item className="step step-2" xs={12}>
      <PersonalInfo />
      <ContactInfo />
    </Grid>,
    <Grid container item className="step step-3" xs={12}>
      <AdressInfo />
    </Grid>,
    <Grid container item className="step step-4" xs={12}>
      <PaymentStep variables={paymentStepArray} paymentStep={false} />
    </Grid>,
    <Grid container item className="step step-5" xs={12}>
      <PaymentStep variables={paymentStepArray} paymentStep={true} />
    </Grid>
  ]

  return (
    <Grid container item className={name ? `${name} steps` : "steps"}>
      {stepContent[step]}
    </Grid>
  )
}